@use "../../styles/breakpoint.module.scss" as *;

.root {
    > *[class*="controls"] {
        inset-inline: calc(40px - var(--container-margin));
    }
}

.page {
    composes: grid from "../../styles/composable/layout.module.css";
}

.unfilledCarousel {
    @media ($above-mobile) {
        .page {
            display: flex;
            justify-content: center;
        }

        &.three_up_wrap .card {
            width: 33.333%;
        }

        &:is(.four_up_wrap) .card {
            width: 33.333%;
        }
    }

    @media ($above-tablet) {
        &:is(.four_up_wrap) .card {
            width: 25%;
        }
    }
}

.card {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: var(--spacer-16);
}

.clicky {
    cursor: pointer;
    position: absolute;
    inset: 0;
    z-index: 1;

    svg {
        display: none;
    }
}

.three_up_wrap {
    .card {
        grid-column: span 4;
    }
}

.four_up_wrap {
    .card {
        grid-column: span 3;
    }

    @media ($below-mobile) {
        .card {
            grid-column: span 2;
        }
    }
}

.four_up_overflow {
    &.unfilledCarousel > * {
        @media ($above-mobile) {
            display: flex;
            justify-content: center;
            gap: var(--grid-gap);
        }
    }

    [aria-roledescription="slide"] {
        width: calc(25% - (var(--grid-gap) * 3 / 4));
        margin-right: var(--grid-gap);
        vertical-align: top;

        &:last-child {
            margin-right: 0;
        }

        @media ($below-tablet) {
            width: calc(33.3333% - (var(--grid-gap) * 2 / 3));
        }

        @media ($below-mobile) {
            width: calc(50% - (var(--grid-gap) * 1 / 2));
        }
    }
}

.richText {
    :is(h1, h2, h3, h4, h5, h6) {
        margin-block: var(--spacer-12);
        font: var(--font-h-24);
    }

    :is(p, li) {
        margin-block: var(--spacer-12);
        font: var(--font-p-16);
    }
}

.richTextOnTop {
    z-index: 2;
}
